<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.solicitacao"
            :tbody-tr-class="rowClass"
            ref="RkmDataTable"
            sort-by="dataSolicitacao"
        >
            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="print(item.id)"
                    color="primary"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="!item.allowEdit"
                    @click="edit(item.id)"
                    authorize="update-manutencao-solicitacao"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    v-if="item.allowDestroy && !item.allowCancel"
                    :disabled="!item.allowDestroy"
                    @click="destroy(item)"
                    authorize="destroy-manutencao-solicitacao"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>

                <rkm-button
                    v-if="!item.allowDestroy"
                    :disabled="!item.allowCancel"
                    @click="openModalCancelamento(item)"
                    authorize="update-manutencao-solicitacao"
                    color="danger"
                    small
                    title="Cancelar"
                >
                    <rkm-icon icon="ban" />
                </rkm-button>

                <rkm-button
                    @click="openModalReabertura(item)"
                    :disabled="!item.allowReopen"
                    authorize="update-manutencao-solicitacao"
                    color="primary"
                    small
                    title="Reabrir"
                >
                    <rkm-icon icon="redo" />
                </rkm-button>

                <rkm-button
                    @click="openModalMensagens(item)"
                    :disabled="!item.mensagensResposta.length > 0"
                    authorize="update-manutencao-solicitacao"
                    color="warning"
                    small
                    title="Responder"
                >
                    <rkm-icon icon="comment" />
                </rkm-button>

                <rkm-button
                    @click="openModalFinalizacao(item)"
                    :color="item.pendenteFinalizacao ? 'success' : 'secondary'"
                    :disabled="!item.pendenteFinalizacao"
                    authorize="update-manutencao-solicitacao"
                    small
                    title="Finalizar"
                >
                    Finalizar
                </rkm-button>
            </template>
        </rkm-data-table>

        <modalCancelamento
            @refresh="load"
            ref="modalCancelamento"
        />

        <modalReabertura
            @refresh="load"
            ref="modalReabertura"
        />

        <modalFinalizacao
            @refresh="load"
            ref="modalFinalizacao"
        />

        <modalMensagens
            @refresh="load"
            ref="modalMensagens"
        />
    </div>
</template>

<script>

// Components.
import modalCancelamento from './components/cancelamento/Modal'
import modalReabertura from './components/reabertura/Modal'
import modalFinalizacao from './components/finalizacao/Modal'
import modalMensagens from './components/mensagem/Modal'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import {error, formats, repository, stringCase, object, file} from '@/mixins'

// Enums.
import statusTipo from '@/enums/manutencao/statusTipo'

export default {
    components: { modalCancelamento, modalReabertura, modalFinalizacao, modalMensagens },
    computed: {
        fields() {
            return [
                {key: 'codigo', label: 'Código', name: 'codigo', searchable: true, sortable: true},
                {key: 'dataSolicitacao', label: 'Data', name: 'dataSolicitacao', searchable: true, sortable: true},
                {key: 'grupo', label: 'Grupo', name: 'grupo', searchable: true, sortable: true},
                {key: 'servico', label: 'Serviço', name: 'servico', searchable: true, sortable: true},
                {key: 'assunto', label: 'Assunto', name: 'assunto', searchable: true, sortable: true},
                {key: 'status', label: 'Status', name: 'status', searchable: true, sortable: true},
                {key: 'usuarioSolicitante', label: 'Usuário solicitante', name: 'usuarioSolicitante', searchable: true, sortable: true},
                {class: 'col-min', key: 'actions', label: 'Ações', name: 'actions'},
            ]
        }
    },
    created() {
        this.repositories = {

            solicitacao: this.getConectaSusRepository('manutencao.solicitacao'),
            impressao: this.getConectaSusRepository('impressao.manutencao'),
        }
    },
    data: () => ({
        enums: { statusTipo },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.$refs.RkmDataTable.refresh()
        },
        rowClass(item, type) {

            if (type === 'row' && item) {

                if (item.mensagemPendente) {

                    return 'table-warning'
                } else {

                    switch (item.tipoStatus) {

                        case this.enums.statusTipo.EM_ATENDIMENTO: {

                            return 'table-success'
                        }
                        case this.enums.statusTipo.CANCELADO: {

                            return 'table-danger'
                        }
                        default: {

                            return ''
                        }
                    }
                }
            }
        },
        edit(id) {

            this.$router.push({name: 'manutencao-solicitacao-edit', params: {id}})
        },
        destroy(item) {
            const destroy = () => this.repositories.solicitacao.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a solicitação?', destroy)
        },
        openModalCancelamento(item) {

            this.$refs.modalCancelamento.open(item)
        },
        openModalReabertura(item) {

            this.$refs.modalReabertura.open(item)
        },
        openModalFinalizacao(item) {

            this.$refs.modalFinalizacao.open(item)
        },
        openModalMensagens(item) {

            this.$refs.modalMensagens.open(item)
        },
        print(id) {

            this.repositories.impressao.solicitacao(id)
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
        }
    },
    mixins: [error, formats, repository, stringCase, object, file],
}
</script>